import { useTranslation } from 'react-i18next'
import { Badge } from '../Badge'
import { RegenCountdown } from '../RegenCountdown'
import { STAMINA_MAX } from '../../hooks/useStamina'

export interface StaminaCardProps {
  current: number
  /** Maximum stamina value. Defaults to {@link STAMINA_MAX} from useStamina. */
  max?: number
  regenSeconds?: number
}

export function StaminaCard({
  current,
  max = STAMINA_MAX,
  regenSeconds = 0,
}: StaminaCardProps) {
  const { t } = useTranslation()
  const pct = Math.min(100, (current / max) * 100)
  const isMax = current >= max

  return (
    <div className="stamina">
      <div className="stamina__label">
        <span>{t('lobby.stamina.label')}</span>
        <span style={{ fontWeight: 600 }}>
          {current}/{max}
        </span>
      </div>
      <div className="stamina__bar">
        <div className="stamina__fill" style={{ width: `${pct}%` }} />
      </div>
      <div style={{ fontSize: 11, textAlign: 'right' }}>
        {isMax ? (
          <Badge variant="new" style={{ height: 18, fontSize: 10 }}>
            {t('lobby.stamina.max')}
          </Badge>
        ) : (
          <>
            <span style={{ opacity: 0.6 }}>+1 </span>
            <RegenCountdown seconds={regenSeconds} />
          </>
        )}
      </div>
    </div>
  )
}
